import React from 'react';
import { getTrancheFieldConfig } from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/Tranche/trancheFieldsConfig';
import styles from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/TrancheField/trancheField.module.scss';

interface ITrancheFieldProps {
  fieldKey: string,
  value: any,
}

const TrancheField = ({ fieldKey, value }: ITrancheFieldProps) => {
  const fieldConfig = getTrancheFieldConfig(fieldKey);

  if (!fieldConfig) {
    return null;
  }

  const { label, formatter } = fieldConfig;
  const formattedValue = formatter(value);

  return (
    <div className={ styles.nameValueRow }>
      <div className={ styles.name }>{ label }</div>
      <div className={ styles.value }>{ formattedValue || '-' }</div>
    </div>
  );
};

export default TrancheField;
